import { Box, Typography, useTheme } from "@mui/material";
import { PRICING_DESIGN_VALUES } from "./pricingDesignValues";

interface PricingEyebrowProps {
  label: string;
  gradient: string;
}

export const PricingEyebrow = ({ label, gradient }: PricingEyebrowProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "32px",
        padding: "4px 16px",
        border: `1px solid ${theme.palette.neutral["015"]}`,
        borderRadius: "32px",
        backgroundColor: theme.palette.neutral.main,
        boxShadow: PRICING_DESIGN_VALUES.shadows.eyebrow,
      }}
    >
      <Typography
        variant="caption-3"
        sx={{
          ...PRICING_DESIGN_VALUES.eyebrowText,
          background: gradient,
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          color: "transparent",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
